declare var Modernizr: any;

const $header: JQuery<HTMLElement> = $('.header');
const header: HTMLElement = $header[0];
const $nav: any = $('.header__navigation');
const $navList: any = $('.header__navigation > ul');
const $search: any = $('.header__search');
const $toggle: any = $('.header__toggle');
const $window: any = $(window);
const $body: any = $('body');
const $headerTop: any = $('.header-top');
const $navigationItemsWithDropdown: any = $(`
  .navigation__item.has-children, .navigation-dropdown__item.has-children
`);

const OPEN_CLASS: string = 'is-opened';
const HAS_CHILDREN_CLASS: string = 'has-children';
const EXPANDED_CLASS: string = 'is-expanded';
const HUNDRED: number = 100;

const MD_MIN_WIDTH: number = 992;
const MD_MAX_WIDTH: number = 991;

const SEARCH_FOCUS_DELAY: number = 600;

const navigation = {
  /**
   * Initialize the navigation
   */
  initialize() {
    this.menuOpen = false;
    this.currentLayer = 1;
    this.headerOffset = $headerTop.outerHeight();
    this.createListeners();

    if ($window.width() < MD_MIN_WIDTH) {
      $nav.attr('aria-expanded', 'false');
    }

    let windowWidth: number = $window.width();
    let prevBP: string = (windowWidth <= MD_MAX_WIDTH) ? 'sm' : 'lg';

    $window.on('resize', () => {
      windowWidth = $window.width();
      let bp: string;

      if (windowWidth <= MD_MAX_WIDTH) {
        bp = 'sm';
      } else {
        bp = 'lg';
      }

      this.headerOffset = $headerTop.outerHeight();

      if (bp !== prevBP) {
        this.destroyEvents();
        this.createListeners();

        $nav.css('height', (bp === 'lg' ? 60 : 0));
      }

      prevBP = bp;
    });
  },

  /**
   * Test if the device is 'small' or mobile
   * @return {Boolean} Is it a small/mobile device?
   */
  isSmallDevice(): boolean {
    return Modernizr.mq(`(max-width: ${MD_MAX_WIDTH}px)`);
  },

  destroyEvents() {
    $toggle.off('click');
    $navigationItemsWithDropdown.off('click', '> a');
    $body.off('touchstart');
    $(`.navigation__item.${HAS_CHILDREN_CLASS}`).off('mouseover').off('mouseout');
    $nav.off('click', '.js-back');
  },

  /**
   * Create events for the navigation
   * @return {Void}
   */
  createListeners() {
    $toggle.on('click', (e: any) => {
      e.preventDefault();

      if (this.menuOpen) {
        this.navClose();
      } else {
        this.navOpen();
      }

      this.menuOpen = !this.menuOpen;
    });

    if (Modernizr.touchevents || this.isSmallDevice()) {
      // $navigationItemsWithDropdown
      //   .on('click', '> a', (e: any) => {
      //     e.preventDefault();

      //     const $clickedEl: any = $(e.currentTarget);

      //     // Toggle the opened class on the parent to make the dropdown visible
      //     $clickedEl.parent().toggleClass(OPEN_CLASS);

      //     // Recheck if we're still on a 'small' device before sliding the navigation
      //     if (this.isSmallDevice()) {
      //       const $dropdown: any = $clickedEl.next();
      //       const $dropdownItems: any = $dropdown.find('> li');

      //       this.currentLayer += 1;

      //       this.slideToLayer(this.currentLayer, $dropdownItems);
      //     }
      //   });

      $body.on('touchstart', (e: any) => {
        const $clickedTarget: any = $(e.target);
        const $headerParent: any = $clickedTarget.parents('.header');

        // Don't do anything if its a 'small' device, we don't want to hide the dropdown
        if (this.isSmallDevice() || $headerParent.length) {
          return true;
        }

        $(`.navigation__item.${OPEN_CLASS}`).removeClass(OPEN_CLASS);

        return true;
      });
    }

    $nav.on('click', '.js-back', (e: any) => {
      e.preventDefault();

      const $backEl: any = $(e.currentTarget);
      const $parentDropdown: any = $backEl.parents('.navigation-dropdown').eq(1);

      this.currentLayer -= 1;

      if ($parentDropdown.length) {
        this.slideToLayer(this.currentLayer, $parentDropdown.find('> li'));
      } else {
        this.slideToLayer(this.currentLayer);
      }

      const TRANSITION_TIMEOUT: number = 300;

      setTimeout(
        () => {
          $backEl.parents(`.${HAS_CHILDREN_CLASS}`).first().removeClass(OPEN_CLASS);
        },
        TRANSITION_TIMEOUT,
      );
    });

    $header.on('click', '.js-search-trigger, .js-search-close', (e: any) => {
      e.preventDefault();
      const isOpen: boolean = $search.hasClass('is-open');
      $search.toggleClass('is-open', !isOpen);
      $header.toggleClass('has-search-open', !isOpen);

      if (!isOpen) {
        setTimeout(
          () => {
            $search.find('[type="search"]').focus();
          },
          SEARCH_FOCUS_DELAY,
        );
      } else {
        $header.find('.js-search-trigger').focus();
      }
    });

    $navList.on('mouseenter', '.navigation__link', () => {
      const $dropdown = $navList.find('.destinations-dropdown');
      const $images = $dropdown.find('img[data-src]');

      $images.toArray().forEach((img: any) => {
        $(img).attr('src', $(img).data('src'));
        $(img).removeAttr('data-src');
      });
    });
  },

  navOpen() {
    this.currentLayer = 1;

    this.slideToLayer(this.currentLayer);

    $(`.${HAS_CHILDREN_CLASS}.${OPEN_CLASS}`).removeClass(OPEN_CLASS);

    $toggle.addClass(EXPANDED_CLASS);
    $toggle.find('span').text($toggle.data('text-close'));

    $nav.attr('aria-expanded', 'true');
  },

  navClose() {
    $nav.css({
      height: 0,
    });

    $toggle.removeClass(EXPANDED_CLASS);
    $toggle.find('span').text($toggle.data('text-menu'));

    $nav.attr('aria-expanded', 'false');
  },

  slideToLayer(level: number, $dropdownItems: any) {
    const slideTo = (level - 1) * HUNDRED * -1;
    const transform = `translateX(${slideTo}%)`;

    $navList.css({
      transform,
      webkitTransform: transform,
      msTransform: transform,
    });

    let $items = $dropdownItems;

    if (typeof $dropdownItems === 'undefined') {
      $items = $nav.find('.navigation__item');
    }

    const height = $items.toArray().reduce(
      (prev: number, item: HTMLElement) => (
        prev + $(item).outerHeight()
      ),
      0,
    );

    $nav.css({
      height,
    });
  },
};

export default navigation;
